import React from "react"

const NetworkOrganisationsContext = React.createContext({})

const { Provider, Consumer } = NetworkOrganisationsContext

export { Provider, Consumer, NetworkOrganisationsContext }
